import {
  TOGGLE_QUICKVIEW,
  HISTORY_PREV_ITEM,
  SAVE_SCROLL_POSITION,
  SET_ADDITIONAL_PARAMS,
} from './action-types';
import {
  openAppQuickView,
  fetchAppQuickviewByAsset,
  requestAppQuickViewDetails,
  cleanupAppRequests,
} from './app-qv';
import { openPubQuickView, updatePubSalesforceStatus, cleanupPubRequests } from './pub-qv';
import { openCompanyQuickView, cleanupCompanyRequests } from './company-qv';

export const handleCleanupRequests = () => {
  cleanupAppRequests();
  cleanupPubRequests();
  cleanupCompanyRequests();
};

export const closeQuickview = () => ({
  type: TOGGLE_QUICKVIEW,
  isOpen: false,
});

export const historyPrevItem = () => ({
  type: HISTORY_PREV_ITEM,
});

export const saveScrollPosition = (scrollPosition) => ({
  type: SAVE_SCROLL_POSITION,
  scrollPosition,
});

export const changeAdditionalParams = (additionalParams) => ({
  type: SET_ADDITIONAL_PARAMS,
  additionalParams,
});

export {
  openAppQuickView,
  openPubQuickView,
  openCompanyQuickView,
  fetchAppQuickviewByAsset,
  requestAppQuickViewDetails,
  updatePubSalesforceStatus,
};
